import { createSlice } from '@reduxjs/toolkit';
import {
    getAuditTrailByTransactionID,
    getFacilityAuditLog,
    getNewNotifications,
    getNotifications,
    getTransactionEventLogs,
} from '../actions/eventsApi';

export const eventsSlice = createSlice({
    name: 'events',
    initialState: {
        isLoading: false,
        error: null,
        facilityLogs: [],
        auditTrailsLogs: [],
        notificationList: [],
        newNotificationList: [],
        notificationTypeCounts: {},
        notificationCat: ' ',
        nextPageNotifyList: {},
        prevPageDetailNotify: [],
        pageActionBtnType: null,
        isViewAllNotify: false,
        selectedNotiTabGroup: [],
        transactionEventLogs: [],
    },
    reducers: {
        getNotificationCat: (state, action) => {
            state.notificationCat = action.payload;
        },
        clearNotificationCat: (state) => {
            state.notificationCat = '';
        },
        updatePrevPageNotification: (state, action) => {
            state.prevPageDetailNotify = action.payload;
        },
        updateNextPrevPage: (state, action) => {
            state.pageActionBtnType = action.payload;
        },
        viewAllNotification: (state, action) => {
            state.isViewAllNotify = action.payload;
        },
        getSelectedNotification: (state, action) => {
            const existingIndex = state.selectedNotiTabGroup.findIndex((item) => item.name === action.payload.name);
            if (existingIndex !== -1) {
                state.selectedNotiTabGroup[existingIndex].row = action.payload.row;
            } else {
                state.selectedNotiTabGroup = [...state.selectedNotiTabGroup, action.payload];
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFacilityAuditLog.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getFacilityAuditLog.fulfilled, (state, action) => {
                state.isLoading = false;
                state.facilityLogs = action.payload;
            })
            .addCase(getFacilityAuditLog.rejected, (state, action) => {
                state.isLoading = false;
                state.facilityLogs = action.payload;
            })
            .addCase(getAuditTrailByTransactionID.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getAuditTrailByTransactionID.fulfilled, (state, action) => {
                state.isLoading = false;
                state.auditTrailsLogs = action.payload;
            })
            .addCase(getAuditTrailByTransactionID.rejected, (state, action) => {
                state.isLoading = false;
                state.auditTrailsLogs = action.payload;
            })
            .addCase(getNotifications.fulfilled, (state, action) => {
                state.isLoading = false;
                state.notificationList = action.payload.notifications;
                state.nextPageNotifyList = action.payload?.nextPage;
            })
            .addCase(getNotifications.rejected, (state, action) => {
                state.isLoading = false;
                state.notificationList = [];
            })
            .addCase(getNewNotifications.pending, (state, action) => {
                state.isLoading = true;
                state.notificationTypeCounts = {};
            })
            .addCase(getNewNotifications.rejected, (state, action) => {
                state.isLoading = false;
                state.notificationTypeCounts = {};
            })
            .addCase(getNewNotifications.fulfilled, (state, action) => {
                state.isLoading = false;
                state.newNotificationList = action.payload.notifications;
                state.notificationTypeCounts = action.payload.count;
            })
            .addCase(getTransactionEventLogs.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getTransactionEventLogs.fulfilled, (state, action) => {
                state.isLoading = false;
                state.transactionEventLogs = action.payload;
            })
            .addCase(getTransactionEventLogs.rejected, (state, action) => {
                state.isLoading = false;
                state.transactionEventLogs = [];
                state.error = action.payload;
            });
    },
});
export const {
    getNotificationCat,
    clearNotificationCat,
    updatePrevPageNotification,
    updateNextPrevPage,
    viewAllNotification,
    getSelectedNotification,
} = eventsSlice.actions;
export default eventsSlice.reducer;
